// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/*
 * Whether a permission map carries practice-management standing.
 *
 * Since the Client Portal module split, the portal client's one permission
 * lives in its own namespace — `access.client-portal.view-client-portal` —
 * so nothing a portal client holds matches the practice-management module
 * prefix. Standing is therefore a plain prefix test: any truthy
 * `access.practice-management.` permission. `portal-user.*` — inviting and
 * listing portal contacts — is accountant-side work under that prefix and
 * counts as standing; the client-portal namespace never does.
 *
 * Pure and exported on its own so it can be tested without the Vue plugin's
 * router/store closure around it.
 */

const MODULE_PREFIX = 'access.practice-management.';

export function hasPracticeManagementStanding(permissionMap) {
    if (!permissionMap || typeof permissionMap !== 'object') {
        return false;
    }

    return Object.keys(permissionMap).some((permission) => permissionMap[permission] && permission.startsWith(MODULE_PREFIX));
}
